// Helpers for the plain-text "lock" messages the backend sends when a firm
// can't generate yet (is_generation_locked and the pay-per-engagement charge in
// backend/main.py). There is no structured error code, so the UI reads the
// wording -- but in ONE place, so every page agrees.

// True when a message tells the firm to act in Billing: "Subscribe from
// Billing…" (unpaid), "Add a payment method in Billing…" (no card), "…update
// your payment method in Billing…" (declined card) and "Update your payment
// method in Billing to continue…" (charge cool-down). The suspended-account
// message says to contact support instead and deliberately does not match.
// Used only to ADD a shortcut button; it never blocks or hides anything.
// (Statements and Management Accounts used to match only "subscribe from
// billing", so the three pay-per-engagement messages never got a button there.)
export function pointsToBilling(message) {
  return typeof message === 'string' && /\bbilling\b/i.test(message)
}

// True while a pay-per-engagement firm's last failed charge is recent enough
// that the backend is still pausing generation. Mirrors
// backend/main.py::_payg_cooldown_active, including its fail-safes: an
// unreadable value is "not paused" (a format surprise must never show a false
// warning), and a timestamp more than a few minutes in the FUTURE is ignored.
export function isChargePauseActive(raw, windowMinutes, nowMs = Date.now()) {
  if (!raw || typeof raw !== 'string') return false
  const failedAt = Date.parse(raw)
  if (Number.isNaN(failedAt)) return false
  const elapsedMin = (nowMs - failedAt) / 60000
  return elapsedMin > -5 && elapsedMin < windowMinutes
}
